import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  FtthResourceService,
  OltCardPortStats,
  Resource,
  resourceListToResourceTypeMap,
  ResSpecificationId
} from '../../../../../services/api/ftth-resource/ftth-resource.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-oltres-widget',
  templateUrl: './oltres-widget.component.html',
  styleUrls: ['./oltres-widget.component.scss']
})
export class OLTResWidgetComponent implements OnInit, OnDestroy {
  private _resource: Resource;

  @Input()
  get resource(): Resource {
    return this._resource;
  }

  set resource(value: Resource) {
    if (value.specificationName === 'OLTResSpec') {
      this._resource = value;
    } else {
      this._resource = undefined;
    }
  }

  contains: { [p in ResSpecificationId]?: Resource[]; };

  stats: OltCardPortStats[][];
  selectedGroup: keyof OltCardPortStats = 'occupiedPortsNumber';

  private subscriptions = new Subscription();

  constructor(
    private ftthResourceService: FtthResourceService,
  ) {
  }

  ngOnInit() {
    this.contains = this.resource ? resourceListToResourceTypeMap(this.resource.contains) : {};
    this.subscriptions.add(
      this.ftthResourceService.getOltCardPortStats(this.resource._links.self.href.split('/')[this.resource._links.self.href.split('/').length-1])
        .subscribe(stats => this.stats = stats)
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  getOccupancy(port: OltCardPortStats) {
    if (port.occupiedPortsRatioNumber >= 0.9) {
      return 'occupancy-danger';
    }
    if (port.occupiedPortsRatioNumber >= 0.8) {
      return 'occupancy-warning';
    }
    if (port.occupiedPortsNumber >= 1) {
      return 'occupancy-occupied';
    }
    return 'occupancy-empty';
  }
}
